import React from "react";
import { observer } from "mobx-react";
import { CreditPurchaseViewStore } from "../../store";
import { CreditPurchaseViewForm } from "./CreditPurchaseViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CreditPurchaseViewProps = {
  creditPurchaseViewStore: CreditPurchaseViewStore;
};

export const CreditPurchaseView: React.FC<CreditPurchaseViewProps> = observer(
  ({ creditPurchaseViewStore }) => {
    return (
      <div>
        <CreditPurchaseViewForm
          tenantValue={creditPurchaseViewStore.tenantValue}
          quantity={creditPurchaseViewStore.quantityValue}
          purchaseDate={creditPurchaseViewStore.purchaseDateValue}
          expirationDate={creditPurchaseViewStore.expirationDateValue}
          unitPrice={creditPurchaseViewStore.unitPriceValue}
          notes={creditPurchaseViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            creditPurchaseViewStore.printCreditPurchase(handlePrint)
          }
          onCancel={() => creditPurchaseViewStore.cancelCreditPurchase()}
          onEdit={
            creditPurchaseViewStore.isEditEnabled
              ? () => creditPurchaseViewStore.editCreditPurchase()
              : undefined
          }
        />
        <ErrorDialog
          open={creditPurchaseViewStore.errorDialogOpened}
          title={creditPurchaseViewStore.errorTitle}
          description={creditPurchaseViewStore.errorDescription}
          onClose={() => creditPurchaseViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
